import "../../vendor/jquery.durationpicker";

export default class QuerySchedulingAppInputsHandler {

    constructor() {
        this.inputs = [];
        this.intervalInput = $('#savedSearchSchedulingIntervalInput');
        this.queryName = $("#queryName");
        this.inputs.push(this.queryName);
        this.token = $("#token");
        this.email = $("#savedSearchSchedulingEmail");
        this.inputs.push(this.email);
        this.query = $("#queryDisplay");
        this.inputs.push(this.query);
        this.queryId = null;
        this.intervalInput.durationPicker({
            showDays: true,
            showHours: true,
            showMins: false,
        });
        this.daysElement = $("select[name=duration-picker-days]");
        this.hoursElement = $("select[name=duration-picker-hours]");
        this.articleTagsLimit = $("#articleTagsLimit");
        this.articleQuotesLimit = $("#articleQuotesLimit");
        this.withSentiments = $("#articleSentimentsOutputCheckbox");
        this.intervalHours = null;
        this.outputFormat = $("#outputFormat");
    }

    reset(){
        const self = this;
     //   self.inputs.forEach(input => input.val(""));
        self.setIntervalDefaultValue();
    }

    init() {
        const self = this;
        const urlParams = new URLSearchParams(window.location.search);
        const queryName = urlParams.get('queryName');
        const token = urlParams.get('token');
        const email = urlParams.get('email');
        const intervalHours = urlParams.get('intervalHours');
        const query = urlParams.get('query');
        const queryId = urlParams.get('queryId');
        if (queryName) {
            this.queryName.val(queryName);
        }
        if (token) {
            this.token.val(token);
        }
        if (email) {
            this.email.val(email);
        }
        if (intervalHours) {
            self.setIntervalValue(intervalHours);
        } else {
            self.setIntervalDefaultValue();
        }
        if (query) {
            this.query.val(decodeURIComponent(query));
        }
        if (queryId) {
            this.queryId = queryId;
        }
        $(".duration-picker-container select").addClass("form-control");
        self.intervalInput.on("change", function ($val) {
            if ($(this).val() === 0) {
                self.setIntervalDefaultValue();
            } else {
                self.intervalHours = Math.floor($(this).val() / 3600);
            }
        });
    }

    getArticleConfig() {
        const self = this;
        const articleTagsLimit = self.articleTagsLimit.val();
        const articleQuotesLimit = self.articleQuotesLimit.val();
        const withSentiments = self.withSentiments.is(":checked");
        const outputFormat = self.outputFormat.val().toLowerCase();
        return {
            articleTagsLimit: articleTagsLimit,
            articleQuotesLimit: articleQuotesLimit,
            withSentiments: withSentiments,
            outputFormat: outputFormat
        };
    }

    setIntervalValue(intervalHours) {
        const self = this;
        const days = Math.floor(intervalHours / 24);
        const hours = intervalHours % 24;
        self.daysElement.val(days);
        self.hoursElement.val(hours);
        self.intervalHours = intervalHours;
    }

    setIntervalDefaultValue() {
        const self = this;
        self.daysElement.val("1");
        self.hoursElement.val("");
        self.intervalHours = Math.floor(24);
        return self;
    }
}